import getApiUrl from './ApiEnv';

const axios = require('axios');

function kebabCaseToCamel(str) {
  return str.replace(/(-\w)/g, (matches) => matches[1].toUpperCase());
}

class API {
  constructor() {
    this.url = getApiUrl();
    this.endpoints = {};
  }

  // const myApi = new API({ url:'http://localhost:8080/api' })
  // myApi.createEntity({ name: 'posts' })
  /**
   * Create and store a single entity's endpoints
   * @param {A entity Object} entity
   */
  createEntity(entity) {
    /**
     * If there is a - in the entity.name, then change it
     * to camelCase. E.g
     * ```
     * myApi.createEntity({ name : 'foo-bar'})
     * myApi.endpoints.fooBar.getAll(...)
     */

    const name = kebabCaseToCamel(entity.name);
    this.endpoints[name] = this.createBasicCRUDEndpoints(entity);
  }

  createEntities(arrayOfEntity) {
    arrayOfEntity.forEach(this.createEntity.bind(this));
  }
  /**
   * Create the basic endpoints handlers for CRUD operations
   * @param {A entity Object} entity
   */

  createBasicCRUDEndpoints({ name }) {
    const endpoints = {};

    const resourceURL = `${this.url}/${name}`;

    endpoints.getAll = (toGet, config = {}, relpath) => axios.get(`${resourceURL}/${relpath || ''}`, toGet, config);

    endpoints.getProducts = (toGet, config = {}, relpath) => axios.get(`${resourceURL}/${relpath || ''}/${toGet.brand_id}`, toGet, config);

    endpoints.send = (values, config = {}, relpath) => axios.post(`${resourceURL}/${relpath || ''}`, values, config);

    endpoints.getOne = ({ id }, config = {}, relpath) => axios.get(`${resourceURL}/${relpath || ''}/${id}`, config);

    endpoints.getById = ({ id }, config = {}, relpath) => axios.get(`${resourceURL}${relpath || ''}/${id}`, config);

    endpoints.create = (toCreate, config = {}, relpath) => axios.post(`${resourceURL}/${relpath || ''}`, toCreate, config);

    endpoints.auth = (credentials, config = {}) => axios.post(`${resourceURL}/auth`, credentials, config);

    endpoints.update = (toUpdate, config = {}, relpath) => axios.put(
      `${resourceURL}/${relpath || ''}/${toUpdate.id || ''}`,
      toUpdate,
      config,
    );

    endpoints.sendMessage = (toUpdate, config = {}, relpath) => axios.post(
      `${resourceURL}/${relpath || ''}/${toUpdate.id}`,
      toUpdate,
      config,
    );

    endpoints.patch = ({ id }, toPatch, config = {}) => axios.patch(`${resourceURL}/${id}`, toPatch, config);

    endpoints.delete = ({ id }, config = {}, relpath) => axios.delete(`${resourceURL}/${relpath || ''}/${id}`, config);

    return endpoints;
  }
}

export default API;
